import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiService } from '@/api';
import {
    PaginatedResponse,
    Rate,
    RatesOptions,
    RatesVisibilitySyncStatus
} from '@/interfaces';

@Injectable({
    providedIn: 'root'
})
export class RatesService {

    constructor(private apiService: ApiService) {
    }

    listing(params: Record<string, any>): Observable<PaginatedResponse<Rate>> {
        return this.apiService.get<any>('/rates', this.apiService.build(params)).pipe(
            map((res: any) => ({
                data: res.data,
                total: res.total,
                current_page: res.current_page,
                per_page: res.per_page
            }))
        );
    }

    export(params: Record<string, any>): Observable<Blob> {
        return this.apiService.postBlob('/rates/export', params);
    }

    uploadPqgRates(file: File): Observable<unknown> {
        const body = new FormData();
        body.append('file', file);
        return this.apiService.post<unknown>('/pqg-rates/upload', body).pipe(
            map((res: any) => res?.data ?? res)
        );
    }

    options(context: Record<string, any> = {}): Observable<RatesOptions> {
        return this.apiService.get<RatesOptions>('/rates/options', this.apiService.build(context)).pipe(
            map(res => res.data ?? res)
        );
    }

    visibilitySyncStatus(): Observable<RatesVisibilitySyncStatus | null> {
        return this.apiService.get<RatesVisibilitySyncStatus | null>('/rates/visibility-sync-status').pipe(
            map((res) => res.data ?? null)
        );
    }

    autocomplete(field: string, query: string, context: Record<string, any> = {}) {
        return this.apiService.get<string[]>(
            `/rates/autocomplete/${field}`,
            this.apiService.build({ ...context, q: query })
        ).pipe(
            map((res: any) => {
                const raw = Array.isArray(res) ? res : (Array.isArray(res?.data) ? res.data : []);
                const seen = new Set<string>();

                return raw
                    .filter((item: unknown): item is string => typeof item === 'string')
                    .map((item: string) => item.trim())
                    .filter((item: string) => item !== '')
                    .filter((item: string) => {
                        if (seen.has(item)) {
                            return false;
                        }

                        seen.add(item);
                        return true;
                    });
            })
        );
    }
}
